import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of } from "rxjs";
import {
  actionTypes,
  loadTableConfigurationFailureAction,
  loadTableConfigurationSuccessAction,
} from "./tcActions";
import { fetchTablesConfiguration } from "./tcServices";

const fetchTablesConfigurationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.LOAD_TABLE_CONFIGURATION),
    mergeMap((action: any) =>
      fetchTablesConfiguration().pipe(
        map((response: any) => loadTableConfigurationSuccessAction(response)),
        catchError((error: any) =>
          of(loadTableConfigurationFailureAction(error))
        )
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [fetchTablesConfigurationEpic];
